import React from 'react';

const ContactText = () => {
  return (
    <div id="contact" className="values-section">
      <h2 className="values-title">Contactez-nous</h2>
      <div className="separator-line"></div>
      <p className="values-description">
        Vous avez un projet en tête ou des questions spécifiques ? Notre équipe est à votre écoute pour vous accompagner et répondre à vos besoins.
        N'hésitez pas à nous contacter pour découvrir comment nous pouvons collaborer et réaliser ensemble vos ambitions.

      </p>
    </div>
  );
};

export default ContactText;
